import { ReloadInterface } from '../interfaces/ReloadInterface';
import { Constructor } from '../../Utility/Mixin';

/**
 * Mixin that will add the {@link ReloadInterface} implemented via a browser
 * based approach.
 * @param Base Class to apply mixin to
 */
// This 'eslint disable' is allowed on mixins as one cannot describe the return
// type since the class is being defined in the mixin.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function BrowserReloadable<TBase extends Constructor>(Base: TBase) {
    return class BrowserReloadable extends Base implements ReloadInterface {
        reloadSignage(): void {
            // Redirect to `start.php`
            window.location.href =
                window.location.protocol +
                '//' +
                window.location.host +
                '/start.php' +
                window.location.search +
                window.location.hash;
        }
    };
}
